<template>
  <tabs :tab-name="['Financials', 'Notes']" color-button="primary">
    <template slot="tab-pane-1">
      <booking-tabs-financials
        :booking="booking"
        :financials="financials"
        @bookingChanged="bookingChanged"
        @transactionAdded="transactionAdded"
      />
    </template>
    <template slot="tab-pane-2">
      <booking-tabs-notes :booking="booking" />
    </template>
  </tabs>
</template>
<script>
import { Tabs } from "@/components";
import BookingTabsFinancials from "./BookingTabsFinancials.vue";
import BookingTabsNotes from "./BookingTabsNotes.vue";

export default {
  components: {
    Tabs,
    BookingTabsFinancials,
    BookingTabsNotes
  },

  props: ["booking", "financials"],

  methods: {
    bookingChanged() {
      this.$emit("bookingChanged", this.booking);
    },
    transactionAdded(transaction) {
      this.$emit("transactionAdded", transaction);
    }
  }
};
</script>
